export default __webpack_public_path__ + "static/media/kayla-overchuk.fe05c48a.jpg";